export default __webpack_public_path__ + "static/0285-ab3eaa1d34f9f1a88902c491a6a0c015.png";